import { Provider } from "@angular/core";

/**
 * service
 */
import { LoadingService } from "../loading.service";
import { LOADING_CONTROL, LOADING_HTTP_CONTROL, LOADING_IS_LOADING } from "./loading-tokens";

/**
 * Array of Angular providers for loading services
 * @constant {Provider[]} LoadingServiceProviders
 * @description Configures dependency injection for all loading-related services and tokens.
 * The LoadingService is provided as the implementation for all loading interfaces.
 * 
 * @example
 * ```typescript
 * // In your module or component
 * providers: [...LoadingServiceProviders]
 * 
 * // Or inject specific services
 * constructor(@Inject(LOADING_CONTROL) private loadingControl: ILoadingControlService) {}
 * constructor(@Inject(LOADING_HTTP_CONTROL) private httpControl: ILoadingHttpControlService) {}
 * constructor(@Inject(LOADING_IS_LOADING) private loadingStatus: ILoadingStatusService) {}
 * ```
 */
export const LoadingServiceProviders: Provider[] = [
  LoadingService,
  { provide: LOADING_CONTROL, useExisting: LoadingService },
  { provide: LOADING_IS_LOADING, useExisting: LoadingService },
  { provide: LOADING_HTTP_CONTROL, useExisting: LoadingService },
]
